import { useState } from 'react';

export function useLineupInfoModal() {
  const [isVisible, setIsVisible] = useState(false);
  const [isCurrentTeam, setIsCurrentTeam] = useState();
  const [shift, setCurrentShift] = useState();
  const [shifts, setShifts] = useState([]);

  const openDialog = (isCurrentTeam, currentShift, shifts) => {
    setIsVisible(true);
    setIsCurrentTeam(isCurrentTeam);
    setCurrentShift(currentShift);
    setShifts(shifts);
  };

  const closeDialog = () => {
    setIsVisible(false);
  };

  const currentShiftIndex = shifts.findIndex(s => s.id === shift.id);
  const hasPrev = currentShiftIndex > 0;
  const hasNext = currentShiftIndex < shifts.length - 1;

  const goPrevShift = () => setCurrentShift(shifts[currentShiftIndex - 1]);
  const goNextShift = () => setCurrentShift(shifts[currentShiftIndex + 1]);

  return {
    isVisible,
    isCurrentTeam,
    shift,
    shifts,
    openDialog,
    closeDialog,
    setCurrentShift,
    hasPrev,
    hasNext,
    goPrevShift,
    goNextShift,
  };
}
